import React from 'react';
import { Link } from 'react-router-dom';
import { FMessage } from '../../hoc/IntlComponents';
import WarningBlock from './WarningBlock';
import { AttensionBlock } from './AttensionBlock';

const VKApiRequestsGuide = () => (
  <div className='guide'>
    <h6><b><FMessage id='transfer-by-api.nav.landing.guide.title'/></b></h6>
    <WarningBlock />
    <AttensionBlock />
    <br/>
    <b><p className='questions-header'>
      <FMessage id='transfer-by-api.nav.vk.guide.header.part-1'/>
      <a href='https://static.offerrum.com/networks/ad1/files/landings/vk.php' target='_blank'>
        <FMessage id='transfer-by-api.nav.vk.guide.header.part-2'/>
      </a>
      <FMessage id='transfer-by-api.nav.vk.guide.header.part-3'/>
    </p></b>
    <ol>
      <li>
        <p>
          <FMessage id='transfer-by-api.nav.vk.guide.part-1'/>
        </p>
      </li>
      <li>
        <p>
          <FMessage id='transfer-by-api.nav.vk.guide.part-2'/>
          <a href='https://vk.com/page-19542789_53869861' target='_blank'>
            <FMessage id='transfer-by-api.nav.vk.guide.part-2.link'/>
          </a>
        </p>
      </li>
      <li>
        <p>
          <FMessage id='transfer-by-api.nav.vk.guide.part-3'/>
        </p>
      </li>
      <p className='warning-wrapper no-margin'>
        <FMessage id='transfer-by-api.guide.more-info-1'/>
        <Link to='/faq/tools/integrations/setup/vk'>
          <FMessage id='transfer-by-api.guide.more-info-2'/>
        </Link>.
      </p>
    </ol>
  </div>
);

export default VKApiRequestsGuide;